/** US-first phone display helpers for the customer app Account page. */

export function digitsOnly(raw: string): string {
  return String(raw ?? "").replace(/\D/g, "");
}

export function toE164(raw: string): string | null {
  let d = digitsOnly(raw);
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length === 10) return `+1${d}`;
  const stripped = String(raw ?? "").replace(/[^\d+]/g, "");
  if (/^\+[1-9]\d{9,14}$/.test(stripped)) return stripped;
  return null;
}

export function formatPhoneDisplay(raw: string): string {
  const stripped = String(raw ?? "").trim();
  if (stripped.startsWith("+") && !stripped.startsWith("+1")) {
    return stripped.replace(/[^\d+]/g, "").slice(0, 16);
  }
  let d = digitsOnly(raw);
  if (d.startsWith("1") && d.length > 10) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function formatE164Pretty(e164: string | null | undefined): string {
  if (!e164) return "";
  const d = digitsOnly(e164);
  if (d.length === 11 && d.startsWith("1")) {
    const n = d.slice(1);
    return `+1 (${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;
  }
  return e164;
}

export function isValidUsPhone(raw: string): boolean {
  const e164 = toE164(raw);
  return Boolean(e164 && /^\+1\d{10}$/.test(e164));
}
